import { render } from "./TopDataTable.vue?vue&type=template&id=6b63c4c7&ts=true"
import script from "./TopDataTable.vue?vue&type=script&lang=ts"
export * from "./TopDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__